// Central editable content for Vivek Parekh Productions.
// All values are placeholders and can be safely replaced with verified data.

export const BRAND = {
  name: "Vivek Parekh Production",
  short: "VPP",
  tagline: "Ad Films · Movie Associations · Celebrity Endorsements",
  founded: "2016",
  city: "Mumbai",
  logo: "/vivek-logo.png",
  instagramHandle: "@_vivekparekhproduction_",
  instagramUrl: "https://www.instagram.com/_vivekparekhproduction_/",
  // Business contact details — confirmed by owner (2026-07)
  phone: "+91 77000 62078",
  phoneHref: "tel:+917700062078",
  whatsapp: "https://wa.me/917700062078",
  email: "vivekparekhproduction@gmail.com",
  address: "Mainframe Premises, Aarey Milk Colony, Goregaon East, Mumbai",
  hours: "Mon – Sat · 10:00 AM – 7:00 PM",
};

// Brands featured in the home "Brands We've Worked With" reel.
// Add a logo URL to `logo` to show the logo instead of the name (added one by one).
export const BRANDS_WORKED_WITH = [
  { name: "Gopal Namkeen", logo: "/brand-logos/gopal-namkeen.png" },
  { name: "Silver Coin", logo: "/brand-logos/silver-coin.png" },
  { name: "Radha TMT", logo: "/brand-logos/radha-tmt.png" },
  { name: "Moira Sariya", logo: "/brand-logos/moira-sariya.png" },
  { name: "Adani Ambuja Cement", logo: "/brand-logos/adani-ambuja-cement.png" },
  { name: "Darshan Incense", logo: "/brand-logos/darshan-incense.png" },
  { name: "Cristos", logo: "/brand-logos/cristos.png" },
  { name: "Sumolex", logo: "/brand-logos/sumolex.png" },
  { name: "Real Plast", logo: "/brand-logos/real-plast.png" },
  { name: "Panama Electric", logo: "/brand-logos/panama-electric.png" },
  { name: "Krishiv", logo: "/brand-logos/krishiv.png" },
  { name: "Oxford Paints", logo: "/brand-logos/oxford-paints.png" },
  { name: "Edify School", logo: "/brand-logos/edify-school.png" },
  { name: "Madhu Kunj", logo: "/brand-logos/madhu-kunj.png" },
  { name: "Ever Green", logo: "/brand-logos/ever-green.png" },
  { name: "Bharat Masala", logo: "/brand-logos/bharat-masala.png" },
  { name: "Action", logo: "/brand-logos/action.png" },
  { name: "Haashh", logo: "/brand-logos/haashh.png" },
  { name: "KAKA PVC Profile", logo: "/brand-logos/kaka-pvc-profile.png" },
  { name: "Agarwal Packers", logo: "/brand-logos/agarwal-packers.png" },
  { name: "GreenSole", logo: "/brand-logos/greensole.png" },
  { name: "Phone Wale", logo: "/brand-logos/phone-wale.png" },
  { name: "Vikram Tea", logo: "/brand-logos/vikram-tea.png" },
  { name: "Proofer", logo: "/brand-logos/proofer.png" },
];

export const STATS = [
  { value: "120+", label: "Film Associations" },
  { value: "40+", label: "Brand Collaborations" },
  { value: "2016", label: "Producing Since" },
  { value: "360°", label: "End-to-End Production" },
];

export const NAV = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Services", id: "services" },
  { label: "Brands", id: "brands" },
  { label: "Contact", id: "contact" },
];

export const IMAGES = {
  heroDirector: "https://images.pexels.com/photos/8089650/pexels-photo-8089650.jpeg?auto=compress&cs=tinysrgb&w=1500",
  cameramanWarm: "https://images.pexels.com/photos/23384400/pexels-photo-23384400.jpeg?auto=compress&cs=tinysrgb&w=1500",
  stairwellFilm: "https://images.pexels.com/photos/23384401/pexels-photo-23384401.jpeg?auto=compress&cs=tinysrgb&w=1500",
  cameraRig: "https://images.pexels.com/photos/34518947/pexels-photo-34518947.jpeg?auto=compress&cs=tinysrgb&w=1500",
  cameraStudio: "https://images.pexels.com/photos/29043650/pexels-photo-29043650.jpeg?auto=compress&cs=tinysrgb&w=1500",
  crewTruck: "https://images.pexels.com/photos/30397430/pexels-photo-30397430.jpeg?auto=compress&cs=tinysrgb&w=1500",
  crewSetup: "https://images.pexels.com/photos/8088386/pexels-photo-8088386.jpeg?auto=compress&cs=tinysrgb&w=1500",
  cameramanSet: "https://images.pexels.com/photos/3411420/pexels-photo-3411420.jpeg?auto=compress&cs=tinysrgb&w=1500",
  celebBlackDress: "https://images.pexels.com/photos/27126945/pexels-photo-27126945.jpeg?auto=compress&cs=tinysrgb&w=1500",
  silhouette: "https://images.pexels.com/photos/37322966/pexels-photo-37322966.jpeg?auto=compress&cs=tinysrgb&w=1500",
  celebBlonde: "https://images.pexels.com/photos/11900126/pexels-photo-11900126.jpeg?auto=compress&cs=tinysrgb&w=1500",
  celebOrange: "https://images.pexels.com/photos/9668972/pexels-photo-9668972.jpeg?auto=compress&cs=tinysrgb&w=1500",
  fashionPink: "https://images.pexels.com/photos/8004390/pexels-photo-8004390.jpeg?auto=compress&cs=tinysrgb&w=1500",
  fashionYellow: "https://images.pexels.com/photos/15130848/pexels-photo-15130848.jpeg?auto=compress&cs=tinysrgb&w=1500",
  redCarpet: "https://images.unsplash.com/photo-1779933445383-293d182fa168?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  redHallway: "https://images.unsplash.com/photo-1614115866447-c9a299154650?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  lampBeam: "https://images.pexels.com/photos/5389616/pexels-photo-5389616.jpeg?auto=compress&cs=tinysrgb&w=1500",
  redSpots: "https://images.pexels.com/photos/5389623/pexels-photo-5389623.jpeg?auto=compress&cs=tinysrgb&w=1500",
};

export const SERVICES = [
  {
    id: "ad-film-making",
    number: "01",
    title: "Ad Film Making",
    short: "Television commercials, digital films and brand campaigns crafted end-to-end.",
    description:
      "From concept development and pre-production to filming and post-production, we create visually compelling advertising films that communicate brand stories and inspire audiences.",
    image: IMAGES.cameramanWarm,
    features: [
      "Television commercials",
      "Digital advertising films",
      "Brand campaigns",
      "Product films",
      "Corporate films",
      "Creative development",
      "Production management",
      "Post-production",
    ],
    detailed: [
      "Creative concept development", "Scriptwriting", "Storyboarding", "Casting",
      "Location scouting", "Set design", "Production planning", "Direction",
      "Cinematography", "Lighting", "Editing", "Colour grading",
      "Sound design", "Motion graphics", "Visual effects", "Television & digital deliverables",
    ],
    cta: "Plan Your Ad Film",
  },
  {
    id: "movie-association",
    number: "02",
    title: "Movie Association",
    short: "Strategic brand opportunities within films and the entertainment industry.",
    description:
      "We help brands explore strategic opportunities within films and the entertainment industry through movie partnerships, promotional associations, integrations, and collaborative campaigns.",
    image: IMAGES.stairwellFilm,
    features: [
      "Movie-brand collaborations",
      "In-film brand integration",
      "Promotional partnerships",
      "Film marketing associations",
      "Entertainment collaborations",
      "Campaign coordination",
    ],
    detailed: [
      "Brand-film partnerships", "Film sponsorship opportunities", "Co-promotional campaigns",
      "In-film integrations", "Product placement coordination", "Movie launch collaborations",
      "Promotional content", "Talent & production coordination",
    ],
    cta: "Explore a Movie Collaboration",
  },
  {
    id: "celebrity-endorsement",
    number: "03",
    title: "Celebrity Endorsement",
    short: "Credible, influential and memorable celebrity-led brand campaigns.",
    description:
      "We connect brands with suitable celebrities and public personalities to create credible, influential, and memorable endorsement campaigns.",
    image: IMAGES.celebBlackDress,
    features: [
      "Celebrity identification",
      "Artist coordination",
      "Endorsement campaign planning",
      "Contract & schedule coordination",
      "Celebrity photoshoots",
      "Brand launch appearances",
      "Social media collaborations",
      "Campaign production",
    ],
    detailed: [
      "Celebrity research & selection", "Brand & celebrity alignment", "Availability coordination",
      "Campaign planning", "Photoshoot & video production", "Appearance coordination",
      "Digital collaborations", "Campaign execution support",
    ],
    cta: "Find the Right Celebrity",
  },
];

export const CATEGORIES = [
  "All Work",
  "Ad Films",
  "Celebrity Campaigns",
  "Movie Associations",
  "Behind the Scenes",
];

export const PROJECTS = [
  {
    id: "p1", name: "Untitled Beverage Campaign", client: "Brand Placeholder",
    category: "Ad Films", year: "2025", image: IMAGES.cameramanWarm,
    description: "A cinematic television commercial concept. Replace with a real campaign.",
  },
  {
    id: "p2", name: "Signature Fragrance Film", client: "Brand Placeholder",
    category: "Celebrity Campaigns", year: "2025", image: IMAGES.celebBlackDress,
    description: "Celebrity-led endorsement film concept. Replace with a confirmed project.",
  },
  {
    id: "p3", name: "Gopal Namkeen × Dhamaal 4", client: "Gopal Namkeen",
    category: "Movie Associations", year: "2026", image: IMAGES.stairwellFilm, featured: true,
    description: "In-film and out-film brand association for the Bollywood comedy Dhamaal 4 — song integrations, seamless scene placements, and promotional campaigns.",
    caseStudy: {
      brand: "Gopal Namkeen (Gopal Snacks)",
      film: "Dhamaal 4",
      director: "Indra Kumar",
      released: "July 2026",
      partnership: "4-year brand partnership",
      objective:
        "Embed Gopal Namkeen naturally within a mainstream Bollywood comedy so the brand travels with the film's mass reach — building recall across theatrical, digital, and social audiences without disrupting the viewing experience.",
      concept:
        "A dual in-film and out-film play: weave the brand into songs and key scenes as an organic part of the story world, then amplify it outside the film through co-promotional campaigns timed to the theatrical release.",
      production:
        "End-to-end coordination between the brand and the film's production — placement planning, song integrations, on-screen scene branding, and a synchronized out-film promotional rollout across marketing channels.",
      scope: [
        "In-film brand integration",
        "Song integrations",
        "On-screen scene placements",
        "Out-film promotional campaigns",
        "Co-promotional marketing",
        "Launch & release coordination",
      ],
      highlights: [
        "Fourth consecutive year of brand partnership with Gopal Namkeen",
        "Positioned among the film's most noticeable brand integrations",
        "Complemented by an association around the Filmfare Awards 2025",
      ],
      filmCast: [
        "Ajay Devgn", "Arshad Warsi", "Riteish Deshmukh", "Jaaved Jaffrey",
        "Sanjay Dutt", "Madhuri Dixit", "Anil Kapoor", "Ravi Kishan",
      ],
      gallery: [IMAGES.stairwellFilm, IMAGES.cameraRig, IMAGES.crewTruck, IMAGES.redCarpet],
      note:
        "Film title, director and cast are publicly available information about Dhamaal 4. Vivek Parekh Production's role was the Gopal Namkeen brand association (in-film and out-film). Cast members are not represented as endorsers of the company.",
    },
  },
  {
    id: "p4", name: "Editorial Fashion Spot", client: "Brand Placeholder",
    category: "Celebrity Campaigns", year: "2024", image: IMAGES.fashionPink,
    description: "Fashion campaign film concept. Replace with a real project.",
  },
  {
    id: "p5", name: "Automotive Launch Film", client: "Brand Placeholder",
    category: "Ad Films", year: "2024", image: IMAGES.cameraRig,
    description: "Product launch commercial concept. Replace with a real campaign.",
  },
  {
    id: "p6", name: "On-Set Documentary", client: "Internal",
    category: "Behind the Scenes", year: "2025", image: IMAGES.crewSetup,
    description: "Behind-the-scenes capture from a placeholder production.",
  },
  {
    id: "p7", name: "Studio Portrait Series", client: "Brand Placeholder",
    category: "Celebrity Campaigns", year: "2023", image: IMAGES.celebOrange,
    description: "Celebrity photoshoot concept. Replace with a confirmed shoot.",
  },
  {
    id: "p8", name: "Filmfare Awards Association", client: "Gopal Namkeen",
    category: "Movie Associations", year: "2025", image: IMAGES.crewTruck,
    description: "Brand association and song-integration campaign around a major film awards property.",
  },
];

export const getProjectById = (id) => PROJECTS.find((p) => p.id === id);

export const WHY_US = [
  {
    title: "Creative Storytelling",
    text: "We transform brand messages into engaging visual experiences.",
  },
  {
    title: "End-to-End Production",
    text: "From the first idea to the final edit, every production stage is professionally managed.",
  },
  {
    title: "Entertainment Industry Network",
    text: "Our industry relationships help brands access meaningful film and celebrity opportunities.",
  },
  {
    title: "Quality Without Compromise",
    text: "Every frame, performance, and production detail is handled with precision.",
  },
];

export const PROCESS = [
  { n: "01", title: "Discovery", text: "Understanding the brand, audience, objectives, budget, and creative requirements." },
  { n: "02", title: "Concept Development", text: "Developing campaign ideas, scripts, treatments, and visual direction." },
  { n: "03", title: "Pre-Production", text: "Finalizing talent, locations, schedules, crew, equipment, and production planning." },
  { n: "04", title: "Production", text: "Executing the shoot with professional direction, cinematography, lighting, and management." },
  { n: "05", title: "Post-Production", text: "Editing, sound design, colour grading, visual effects, graphics, and final mastering." },
  { n: "06", title: "Delivery", text: "Finished content for television, cinema, digital platforms, and social media." },
];

export const CELEBRITY_CAPABILITIES = [
  "Celebrity campaign planning",
  "Brand-personality matching",
  "Campaign shoot production",
  "Promotional appearances",
  "Digital & social collaborations",
  "Talent scheduling & coordination",
];

export const CELEBRITY_GALLERY = [
  IMAGES.celebBlackDress, IMAGES.celebBlonde, IMAGES.celebOrange,
  IMAGES.fashionPink, IMAGES.silhouette, IMAGES.fashionYellow,
];

export const BTS_GALLERY = [
  { src: IMAGES.crewSetup, label: "Set & Lighting" },
  { src: IMAGES.cameramanWarm, label: "Camera Department" },
  { src: IMAGES.crewTruck, label: "Night Shoot" },
  { src: IMAGES.cameraRig, label: "Cinema Rig" },
  { src: IMAGES.cameramanSet, label: "On Location" },
  { src: IMAGES.stairwellFilm, label: "Direction" },
  { src: IMAGES.lampBeam, label: "Studio Lighting" },
  { src: IMAGES.celebOrange, label: "Talent Prep" },
  { src: IMAGES.cameraStudio, label: "Post & Review" },
];

// Clearly-marked placeholder testimonials (replace with authentic ones)
export const TESTIMONIALS = [
  {
    name: "Client Name (Placeholder)", role: "Marketing Lead, Brand Placeholder",
    quote: "Placeholder testimonial — replace with an authentic quote from a real partner once available.",
  },
  {
    name: "Client Name (Placeholder)", role: "Founder, Agency Placeholder",
    quote: "Placeholder testimonial — this space is reserved for genuine client feedback.",
  },
  {
    name: "Client Name (Placeholder)", role: "Brand Manager, Placeholder Co.",
    quote: "Placeholder testimonial — insert verified client words here. Do not fabricate claims.",
  },
];

export const VALUES = [
  { title: "Creativity", text: "Ideas that cut through noise and stay with audiences." },
  { title: "Precision", text: "Meticulous craft at every stage, from brief to final cut." },
  { title: "Integrity", text: "Honest counsel and transparent collaboration with every partner." },
  { title: "Impact", text: "Work measured by the response it creates, not just the frames." },
];

export const SHOWREEL = {
  // Replace with the company's YouTube/Vimeo showreel embed URL
  embedUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
  poster: IMAGES.cameramanWarm,
};
